import React from "react"
import PropTypes from "prop-types"
import SegueLinkAction from "sheets/components/cells/action-buttons/SegueLinkAction"

/**
 * Edit button for PAC filings. Disabled if fields.isEditable is false.
 * fields.editPath should be the PacFile detail route.
 */
const EditPacFileAction = ({ fields, editPath, ...theRest }) => {
    const disabled = !fields.isEditable
    const updatedFields = fields && {
        ...fields,
        disabled,
        segueLinkPath: fields.editPath,
    }
    return (
        <SegueLinkAction
            title={disabled ? "Cannot edit a filing that is currently in progress." : undefined}
            fields={updatedFields}
            {...theRest}
        />
    )
}

EditPacFileAction.propTypes = {
    type: PropTypes.string,
    icon: PropTypes.string,
    text: PropTypes.string.isRequired,
    fields: PropTypes.object.isRequired,
}

export default EditPacFileAction
